import {
  type CreateVehicleTypeRequest,
  type UpdateVehicleTypeRequest,
  type VehicleTypeDetail,
  VehicleTypeDetailSchema,
  type VehicleTypeListQuery,
  type VehicleTypeListResponse,
  VehicleTypeListResponseSchema,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

export const listVehicleTypes = async (
  query: VehicleTypeListQuery,
): Promise<VehicleTypeListResponse> => {
  const { data } = await apiClient.get<unknown>('/vehicle-types', { params: query });
  return VehicleTypeListResponseSchema.parse(data);
};

export const getVehicleType = async (id: string): Promise<VehicleTypeDetail> => {
  const { data } = await apiClient.get<unknown>(`/vehicle-types/${id}`);
  return VehicleTypeDetailSchema.parse(data);
};

export const createVehicleType = async (
  payload: CreateVehicleTypeRequest,
): Promise<VehicleTypeDetail> => {
  const { data } = await apiClient.post<unknown>('/vehicle-types', payload);
  return VehicleTypeDetailSchema.parse(data);
};

export const updateVehicleType = async (
  id: string,
  payload: UpdateVehicleTypeRequest,
): Promise<VehicleTypeDetail> => {
  const { data } = await apiClient.patch<unknown>(`/vehicle-types/${id}`, payload);
  return VehicleTypeDetailSchema.parse(data);
};

export const deleteVehicleType = async (id: string): Promise<void> => {
  await apiClient.delete(`/vehicle-types/${id}`);
};

export const bulkDeleteVehicleTypes = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/vehicle-types/bulk-delete', { ids });
  return data;
};

export const bulkSetVehicleTypesStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/vehicle-types/bulk-set-status', { ids, isActive });
  return data;
};
